import StoreBaseService from './base.js'

export default class EphemeralStoreService extends StoreBaseService {
    constructor() {
        super(window && window.sessionStorage)
        this.shareBetweenTab()
    }

    shareBetweenTab() {
        if (!sessionStorage.length) {
            // Ask other tabs for session storage
            localStorage.setItem('getSessionStorage', Date.now())
        }

        window.addEventListener('storage', function (event) {
            let currentTimestamp = 0
            if (event.key === 'sessionStorage')
                currentTimestamp = event.newValue ? JSON.parse(event.newValue).timestamp : 0
            if (event.key === 'getSessionStorage') {
                // Some tab asked for the sessionStorage -> send it
                localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage))
                localStorage.removeItem('sessionStorage')
            }
            else if ((event.key === 'sessionStorage' && sessionStorage.length === 0) || sessionStorage.getItem('timestamp') < currentTimestamp) {
                // sessionStorage is empty -> fill it or update latest sessionStorage
                const data = JSON.parse(event.newValue)
                sessionStorage.setItem('timestamp', currentTimestamp)
                for (const key in data) {
                    sessionStorage.setItem(key, data[key])
                }
            }
            else if ((event.key === 'auth0:token:expires_at')) {
                sessionStorage.setItem('workspace', 'logout')
            }
        })
    }
}



// WEBPACK FOOTER //
// src/services/ephemeral-store/index.js